import React, { useEffect } from 'react'

import {
	IOSEventType,
	IOSMessageHandlerName,
	isLaunchedAsIOSApp,
	postMessageToIOSWebView,
	subscribeForIOSEvent,
} from '@/lib/ios'
import { useUser } from '@/lib/react-hooks/generic-hooks'
import { loadData } from '@/lib/requests/loadData'
import { HTTPMethod } from '@/lib/requests/types'
import { useLoadLanguages } from '@/organisms/InvoiceProfile/OnboardingInvoiceProfile/useLoadLanguages'

export const AuthenticatedAppStateFetch: React.FC = () => {
	const user = useUser()

	const userId = user?.id

	useLoadLanguages(!!userId)

	useEffect(() => {
		if (!userId || !isLaunchedAsIOSApp()) {
			return
		}

		postMessageToIOSWebView(IOSMessageHandlerName.PushPermissionRequest, undefined)

		let timeoutId: number | undefined = undefined

		const unsubscribe = subscribeForIOSEvent(IOSEventType.PushToken, ({ detail }) => {
			if (detail) {
				loadData({
					resourcePath: `users/${userId}/device_token`,
					method: HTTPMethod.POST,
					data: { device_token: detail },
				})
			} else {
				timeoutId = window.setTimeout(
					() => postMessageToIOSWebView(IOSMessageHandlerName.PushToken, undefined),
					60 * 1000,
				)
			}
		})

		postMessageToIOSWebView(IOSMessageHandlerName.PushToken, undefined)

		return () => {
			unsubscribe()
			if (timeoutId) {
				clearTimeout(timeoutId)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userId])

	return null
}
